import type { EmployeesContractsManager } from "@/pages/human-resources/time-management/business/EmployeesContractsManager.ts";
import type { Schedule } from "@/pages/human-resources/time-management/business/schedule/Schedule.ts";
import { groupBy } from "@/shared/utils/Arrays.ts";
import type { Employee } from "@/pages/human-resources/time-management/business/Employee.ts";
import { EmployeeSchedules } from "@/pages/human-resources/time-management/business/EmployeeSchedules.ts";

export class SchedulesManager {
  public readonly contractsManager: EmployeesContractsManager;
  private readonly employeeSchedules: Map<string, EmployeeSchedules>;
  constructor(
    contractsManager: EmployeesContractsManager,
    schedules: Schedule[],
  ) {
    this.contractsManager = contractsManager;
    const schedulesByEmployeeId = groupBy(schedules, (s) => s.employeeId);
    this.employeeSchedules = new Map(
      contractsManager
        .listEmployees()
        .map((employee) => [
          employee.id,
          new EmployeeSchedules(
            employee,
            schedulesByEmployeeId.get(employee.id) ?? [],
          ),
        ]),
    );
  }

  public listEmployees(): Employee[] {
    return this.contractsManager.listEmployees();
  }

  public listSchedules(): EmployeeSchedules[] {
    return [...this.employeeSchedules.values()];
  }
}
